import styles from './visualisationbutton.module.scss';
import { useSelector } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation';
import { getWorkplaceStyleById } from 'services/inSite/workplaceStyles';
import searchParams from 'constants/searchParams';
import { openUrlInNewTab } from 'utils/paths';

export default function VisualisationButton(props) {
  const { space, buttonClass, iconClass } = props;
  const params = new URLSearchParams(window.location.search);
  const preview = params.get(searchParams.preview);
  const isExternalAccess = useSelector((state) => state.general.isExternalAccessMode);
  const isReadOnlyMode = useSelector((state) => state.general.isReadOnlyMode);

  const openVisualisation = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const workplaceStyle = getWorkplaceStyleById(space.id);
    openUrlInNewTab(workplaceStyle.visualisationUrl);
  };

  return (
    !isReadOnlyMode &&
    !isExternalAccess &&
    !preview && (
      <IconButton
        data-testid="SpaceVisualisationButton"
        aria-label="spacevisualisation"
        className={`${styles.spacevisualisation} ${styles.button} ${
          buttonClass || styles['button--default']
        }`}
        onClick={(event) => openVisualisation(event)}>
        <ThreeDRotationIcon className={`${styles.icon} ${iconClass || styles['icon--default']}`} />
      </IconButton>
    )
  );
}
